const displayMoney = (value: number) => value.toFixed(2)
const removeZeroPence = (value: string) => value.replace(/\.00$/, '')
const prependPoundSign = (value: string) => '£'.concat(value)
const handleNegativeNumbers = (value: string) => value.replace('£-', '£')
const convertPenceAmountToPounds = (amount: number) =>
  `${(amount / 100).toFixed(2)}`

export const pricePresenterWithPence = (value: number) =>
  handleNegativeNumbers(prependPoundSign(displayMoney(value)))

export const pricePresenterFromPenceToPoundsWithPence = (value: number) =>
  handleNegativeNumbers(prependPoundSign(convertPenceAmountToPounds(value)))

export const pricePresenter = (value: number) =>
  removeZeroPence(handleNegativeNumbers(prependPoundSign(displayMoney(value))))

export const pricePresenterFromPenceToPounds = (value: number) =>
  removeZeroPence(
    handleNegativeNumbers(prependPoundSign(convertPenceAmountToPounds(value)))
  )
